import { useGetEntities } from '@abaninja/util-store';

import { getDocuments } from '../documents';

export const useDocumentsStore = () => useGetEntities(getDocuments);
